import React from 'react';
import Navbar from './Navbar';

const ErrorAccess = () => {
  console.log('inside error')
  return (
    <div style={{ height: '100vh' }}>
      <Navbar />
      <div className='errorClass'>
          <h3>Sorry, you do not have sufficient permissions to view the DL scorecard dashboard.</h3>
            <p>Please reach to your DEX lead.</p>
        </div>

    </div>
  );
};

export default ErrorAccess;
